// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"89":"b333e6","142":"da5c77","345":"46af85","534":"432f0b","557":"bf4e9e","679":"358baf"}[chunkId] + ".js";
};